// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Languages_root__NaOxe {
  padding: 15px 40px 90px 40px;
  height: calc(100vh - 188px);
  overflow-y: scroll;
  color: var(--color-font-10);
  overflow: scroll;
  margin-right: auto;
  margin-left: auto;
}

.Languages_languages_container__tJlvz {
  display: flex;
}

.Languages_language_list_container__BILfC {
  position: fixed;
  left: 210px;
  top: 91px;
  width: 290px;
  background-color: var(--color-bg-caselist);
  overflow: scroll;
  padding: 10px;
  overflow-x: hidden;
  height: calc(100vh - 140px);
}

.Languages_tabs_and_content_container__uULWp {
  width: 950px;
  overflow: hidden;
  margin-left: 310px;
  background-color: var(--color-bg-content);
}

.Languages_add_language_container__Fqf73 {
  background-color: var(--color-bg-caselist);
  display: flex;
  overflow: hidden;
  justify-content: flex-end;
}

.Languages_btn_add_language__zHx7D {
  font-weight: 600 !important;
  color: var(--color-theme-10) !important;
  height: 40px;
}

.Languages_btn_add_language__zHx7D:hover {
  color: var(--color-theme-blue) !important;
  background-color: var(--color-theme-lightblue) !important;
}

.Languages_plus_sign__UY4vi {
  margin-right: 10px;
  font-size: 20px;
}

.Languages_translation_no_data__HBT6P {
  text-align: center;
  margin-top: 300px;
  text-transform: uppercase;
  font-size: 24px;
  color: var(--color-theme-silver);
}
`, "",{"version":3,"sources":["webpack://./src/@_pages/Languages/Languages.module.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,YAAY;EACZ,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAGlB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;EACvC,YAAY;AACd;;AAEA;EACE,yCAAyC;EACzC,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,gCAAgC;AAClC","sourcesContent":[".root {\n  padding: 15px 40px 90px 40px;\n  height: calc(100vh - 188px);\n  overflow-y: scroll;\n  color: var(--color-font-10);\n  overflow: scroll;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n.languages_container {\n  display: flex;\n}\n\n.language_list_container {\n  position: fixed;\n  left: 210px;\n  top: 91px;\n  width: 290px;\n  background-color: var(--color-bg-caselist);\n  overflow: scroll;\n  padding: 10px;\n  overflow-x: hidden;\n  height: -webkit-calc(100vh - 105px);\n  height: -moz-calc(100vh - 105px);\n  height: calc(100vh - 140px);\n}\n\n.tabs_and_content_container {\n  width: 950px;\n  overflow: hidden;\n  margin-left: 310px;\n  background-color: var(--color-bg-content);\n}\n\n.add_language_container {\n  background-color: var(--color-bg-caselist);\n  display: flex;\n  overflow: hidden;\n  justify-content: flex-end;\n}\n\n.btn_add_language {\n  font-weight: 600 !important;\n  color: var(--color-theme-10) !important;\n  height: 40px;\n}\n\n.btn_add_language:hover {\n  color: var(--color-theme-blue) !important;\n  background-color: var(--color-theme-lightblue) !important;\n}\n\n.plus_sign {\n  margin-right: 10px;\n  font-size: 20px;\n}\n\n.translation_no_data {\n  text-align: center;\n  margin-top: 300px;\n  text-transform: uppercase;\n  font-size: 24px;\n  color: var(--color-theme-silver);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Languages_root__NaOxe`,
	"languages_container": `Languages_languages_container__tJlvz`,
	"language_list_container": `Languages_language_list_container__BILfC`,
	"tabs_and_content_container": `Languages_tabs_and_content_container__uULWp`,
	"add_language_container": `Languages_add_language_container__Fqf73`,
	"btn_add_language": `Languages_btn_add_language__zHx7D`,
	"plus_sign": `Languages_plus_sign__UY4vi`,
	"translation_no_data": `Languages_translation_no_data__HBT6P`
};
export default ___CSS_LOADER_EXPORT___;
